import React, { useEffect, useState } from "react";
import axios from "../../axiosConfig";
import "../../styles/inputs-Css/ClientInputs.css";

const AdminReviewList = () => {
  const [reviews, setReviews] = useState([]);
  const [downloadError, setDownloadError] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.get("/reviews", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setReviews(res.data);
      } catch (err) {
        console.error("Error fetching reviews:", err);
      }
    };

    fetchReviews();
  }, []);

  const handleDownload = async (filePath) => {
    try {
      setDownloadError(null);
      const token = localStorage.getItem("token");
      const filename = filePath.split("/").pop();

      const response = await axios.get(`/reviews/download/${encodeURIComponent(filename)}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/octet-stream",
        },
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Review file download failed:", err);
      setDownloadError("Failed to download file. Please try again later.");
      alert("Failed to download file. Please try again later.");
    }
  };

  const handleDownloadAll = async (review_id) => {
    try {
      setDownloadError(null);
      const token = localStorage.getItem("token");
      const response = await axios.get(`/reviews/${review_id}/download-all`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/zip",
        },
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `review_${review_id}_files.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Failed to download all files.");
    }
  };

  const renderFileAction = (review) => {
    if (review.review_id) {
      return (
        <button
          type="button"
          onClick={() => handleDownloadAll(review.review_id)}
          className="btn btn-secondary ci-download-btn"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download All Files (ZIP)
        </button>
      );
    }

    const singlePath = review.file_path || review.file_url || review.filename;
    if (singlePath) {
      return (
        <button
          type="button"
          onClick={() => handleDownload(singlePath)}
          className="btn btn-secondary ci-download-btn"
        >
          Download
        </button>
      );
    }

    return <span className="ci-no-file">No File uploaded</span>;
  };

  return (
    <div className="client-inputs-page">
      <div className="page-head">
        <div>
          <h1 className="page-title">User Submitted Reviews</h1>
          <p className="page-desc">
            Feedback and files reviewers have sent back on published books.
          </p>
        </div>
      </div>

      {downloadError && <div className="empty-note ci-error">{downloadError}</div>}

      <div className="panel">
        {reviews.length === 0 ? (
          <div className="empty-note">No reviews found.</div>
        ) : (
          <div className="table-wrap">
            <table className="ci-table">
              <thead>
                <tr>
                  <th>Book title</th>
                  <th>ISBN</th>
                  <th>Submitted by</th>
                  <th>Subject</th>
                  <th>Description</th>
                  <th>Submitted at</th>
                  <th>File</th>
                </tr>
              </thead>
              <tbody>
                {reviews.map((review) => (
                  <tr key={review.review_id || review.id}>
                    <td className="cell-title">{review.book_title || "General"}</td>
                    <td>{review.isbn_code || "—"}</td>
                    <td>{review.user_name || "Unknown"}</td>
                    <td className="ci-subject">{review.subject || "—"}</td>
                    <td className="ci-desc">{review.description || "—"}</td>
                    <td className="ci-time">
                      {review.submitted_at
                        ? new Date(review.submitted_at).toLocaleString()
                        : "—"}
                    </td>
                    <td className="ci-file-cell">{renderFileAction(review)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminReviewList;
